import {AfterViewInit, ChangeDetectorRef, Directive, ElementRef, Inject, Input, OnChanges} from "@angular/core";
import {ELEMENT_TOKEN, IElementService} from "../../../element/element.service";
import {Observable} from "rxjs";

@Directive({
	selector: '[cpFocus]',
})
export class FocusDirective implements AfterViewInit, OnChanges {
	@Input() cpFocus : boolean = true; // initial status of focus
	@Input() cpFocusOnChanges : boolean = false; // set as false not to change existing behavior

	constructor(@Inject(ELEMENT_TOKEN) private elService: IElementService,
				public cd:ChangeDetectorRef,public elementRef: ElementRef) {
	}


	public ngOnChanges(){
		if ((this.cpFocusOnChanges)&&(this.cpFocus)) {
			setTimeout(() => this.focus());
		}
	}
	public ngAfterViewInit() {
		if (this.cpFocus) {

			setTimeout(
				() => {
					this.focus();
					//console.log("In cp focus ngAfterViewInit CB")
				},0

			);
		}
	}

	public focus() {
		this.elService.focus(this.elementRef);
	}

	public blur() {
		this.elService.blur(this.elementRef);
		this.cd.markForCheck();
	}

	public isFocused(){
		return this.elService.isFocused(this.elementRef);
	}

	public focusedChanged(){
		return this.elService.focusedChanged(this.elementRef);
	}
}
